import { render, staticRenderFns } from "./DashboardNewLaunchesWidget.vue?vue&type=template&id=5a76168c&scoped=true"
import script from "./DashboardNewLaunchesWidget.vue?vue&type=script&lang=js"
export * from "./DashboardNewLaunchesWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardNewLaunchesWidget.vue?vue&type=style&index=0&id=5a76168c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76168c",
  null
  
)

export default component.exports